<template>
  <v-dialog
    v-model="dialog"
    persistent
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        outlined
        :class="btnClass"
        :color="btnColor"
        v-on="on"
        @click="$emit('show')"
      >
        <v-icon>mdi-account-edit</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <span
          class="title"
          style="max-width: 80%"
        >
          {{ $t('field.client_edit') }}
        </span>
        <v-btn
          v-show="!showDirect"
          color="error"
          class="ml-auto"
          icon
          outlined
          @click="delInfos"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-form @submit.prevent="validName">
          <v-text-field
            ref="clientName"
            v-model="name"
            :prepend-inner-icon="IconEnum.client_field"
            :label="$t('field.client_name')"
            name="clientName"
            class="pt-0 needsclick"
            type="text"
          />
          <input
            type="submit"
            style="display: none"
          >
        </v-form>
        <v-dialog
          ref="dialog"
          v-model="modal"
          :return-value.sync="date"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateFormatted"
              :prepend-inner-icon="IconEnum.date_field"
              :label="$t('title.validity_date')"
              class="pt-0 needsclick"
              readonly
              v-on="on"
            />
          </template>
          <v-card>
            <div class="subheading text-center pa-1">
              {{ $t('title.validity_date_selection') }}
            </div>
            <v-divider />
            <v-date-picker
              v-model="date"
              locale="fr-FR"
              scrollable
              :min="(new Date()).toISOString()"
            >
              <v-btn
                color="error"
                text
                @click="modal = false"
              >
                {{ $t('words.cancel') }}
              </v-btn>
              <v-spacer />
              <v-btn
                color="success"
                text
                @click="$refs.dialog.save(date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-card>
        </v-dialog>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-btn
          color="error"
          text
          @click="cancel"
        >
          {{ $t('words.cancel') }}
        </v-btn>
        <v-spacer />
        <v-btn
          color="success"
          text
          :disabled="disabled"
          @click="valid"
        >
          {{ $t('words.valid') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Utils } from 'moduleutils'
import { IconEnum } from '@/modules/Enums'

export default {
  name: 'ClientInfos',

  props: {
    btnClass: { type: String, default: null },
    btnColor: { type: String, default: null },
    scanDate: { type: String, default: null },
    scanName: { type: String, default: null },
    showDirect: { type: Boolean, default: false }
  },

  data () {
    return {
      IconEnum,
      dialog: false,
      modal: false,
      name: '',
      date: ''
    }
  },

  computed: {
    dateFormatted () {
      return Utils.formatDate(this.date)
    },
    disabled () {
      return this.showDirect ? (
          this.name === '' || this.name === null ||
          this.date === '' || this.date === null
        ) : (
          (this.name === '' || this.name === null) &&
          (this.date === '' || this.date === null)
        )
    }
  },

  mounted () {
    this.dialog = this.showDirect
  },

  methods: {
    cancel () {
      this.$emit('cancel')
      this.$emit('hide')
      this.dialog = false
      this.name = this.scanName
      this.date = this.scanDate
    },
    valid () {
      this.$emit('setInfos', this.name, this.date)
      this.$emit('hide')
      this.dialog = false
    },
    delInfos () {
      this.$emit('setInfos', null, null)
      this.$emit('hide')
      this.name = ''
      this.date = ''
      this.dialog = false
    }
  }
}
</script>
